export const EXTERNAL_LINKS = {
  HOW_TO_INSTALL:
    "https://sameitem.pioneera.io/en/article/how-to-install-same-item-multiple-boards-on-your-mondaycom-account-18t4gn8/",
  AUTOMATIONS:
    "https://sameitem.pioneera.io/en/article/automations-how-to-add-the-same-item-to-other-boards-automatically-3s7nbg/",
  HOW_TO_USE: "https://sameitem.pioneera.io/en/article/quick-start-guide-1g573h3/",
};
